var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAlertHttp)?_c('alert-http',{attrs:{"error":_vm.error},on:{"close":function($event){return _vm.$emit('close', $event)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }